
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, PhotoViewModel } from "@tylertech/tyler-api-types";

/**
 * EmployeePhotoService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class EmployeePhotoService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetPhoto(pEmpId: string): Promise<ExecutionResult<PhotoViewModel>> {
        return this.$apiService.sendAuth("IEmployeePhotoService/GetPhoto", pEmpId);
    }
}
